import React from 'react'
import { func, node } from 'prop-types'
import ContentModal from '../ContentModal'

class ContentClickModal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      open: this.props.open
    }
    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
  }

  handleOpen() {
    this.setState({
      open: true
    })
  }

  handleClose() {
    this.setState({
      open: false
    })
    this.props.onClose && this.props.onClose()
  }

  render() {
    const { onClose, ...other } = this.props
    return [
      <span key="ccm:1" style={{ cursor: 'pointer' }} onClick={this.handleOpen}>
        {this.props.clicker}
      </span>,
      <ContentModal
        key="ccm:2"
        open={this.state.open}
        onClose={this.handleClose}
        {...other}
      >
        {this.props.children}
      </ContentModal>
    ]
  }
}

ContentClickModal.propTypes = {
  children: node,
  clicker: node,
  onClose: func
}

export default ContentClickModal
